import Image from 'app/Components/Shared/Image/image';
import React  from 'react';
import Config from '../../../../../Config';

const PackageBanner = (props) => {

  return (
    <div className='sale-energy-package-banner'>
      {props.isBigBanner ?
      <div className='big-banner'>
        <div className='right-banner'>
          <div className='banner-title'>המסלול שלי</div>
          <div className='package-name'>{props.package.title}</div>
          <div className='details-wrapper'>
            {props.package?.details?.map((item, index) => {
              if(item.text){
                return (<div key={index} className='detail'>
                <Image src={Config.epiBaseUrl + item.icon} />
                <span>{item.text}</span>
                </div>)
              }
            })}
          </div>
        </div>
        <div className='left-banner'>
          <div className='package-price'>{props.package.priceText}</div>
          <Image className='package-image' src={require('../../images/electricity.svg')} />
        </div>
        </div> :
            <div className='small-banner'>
            <div className='right-banner'>
              <div>המסלול שלי | <span className='package-name'>{props.package.title}</span></div>
            </div>
            <div className='left-banner'>
            <div className='package-price'>{props.package.priceText}</div>
            </div>
          </div>
       }
    </div>
  );
};

export default PackageBanner;
